
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Container, Row, Col } from "react-bootstrap";
import TrackVisibility from 'react-on-screen';
const servicesData = [
    {
      title: "Web Development",
      description: "Building modern and responsive websites using the latest technologies .",
      icon: "🌐"
    },
    {
      title: "Mobile App ",
      description: "Creating cross-platform mobile applications for iOS and Android using React Native ",
      icon: "📱"
    },
    {
      title: "Bug Fixing ",
      description: "Providing professional debugging,  and regular maintenance for your existing projects.",
      icon: "🔧"
    },
    {
      title: "API Development",
      description: "Developing RESTful and GraphQL APIs for efficient data exchange and smooth backend communication.",
      icon: "⚡"
    },
    {
      title: "Database Design",
      description: "Designing and optimizing databases with MySQL, MongoDB, and Redis for high speed and reliability.",
      icon: "🗄️"
    },
    {
      title: "UI Design",
      description: "Crafting user-friendly interfaces focused on clear design, accessibility, and seamless interaction.",
      icon: "🎨"
    },
    {
      title: "Deployment ",
      description: "Deploying  apps on cloud or hosting , with setup, monitoring, and full server care.",
      icon: "☁️"
    }
  ];
  

export const Services = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 3
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="services" id="services">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <div className="services-bx">
                    <h2>Services</h2>
                    <p>I offer comprehensive development services to help you turn your ideas into reality.</p>

                    <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme services-slider">
                      {servicesData.map((service, index) => (
                        <div  className="item mx-2" key={index}>
                          <div className="service-card">
                            <div className="service-icon">
                              <span>{service.icon}</span>
                            </div>
                            <h5>{service.title}</h5>
                            <p>{service.description}</p>
                          </div>
                        </div>
                      ))}
                    </Carousel>
                  </div>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
